/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
    color: "inherit",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  // Force menu item icons and text to proper color in light mode
  ".MuiMenuItem-root .MuiIcon-root, .MuiMenuItem-root .material-icons-round, .MuiMenuItem-root .material-icons": {
    color: "rgba(0, 0, 0, 0.87) !important",
  },
  ".MuiMenuItem-root": {
    opacity: "1 !important",
  },
  // Mac-like scrollbar styles
  "*::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
  },
  "*::-webkit-scrollbar-track": {
    background: "transparent",
    borderRadius: "4px",
  },
  "*::-webkit-scrollbar-thumb": {
    background: "rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
    border: "2px solid transparent",
    backgroundClip: "content-box",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.35)",
      backgroundClip: "content-box",
    },
  },
  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0, 0, 0, 0.2) transparent",
  },
};

export default globals;
